import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { BrandBar } from "@/components/landing/BrandBar";

const LINKS = [
  { label: "Platform", href: "#platform" },
  { label: "Intelligence", href: "#intelligence" },
  { label: "Pricing", href: "#pricing" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <BrandBar />
    <header className="glass-nav h-16 sm:h-20" data-testid="main-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link" aria-label="OPERA360 home">
          <Logo />
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-muted-foreground hover:text-slate-900 transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/certification"
            data-testid="nav-link-certification"
            className="text-sm font-medium text-muted-foreground hover:text-slate-900 transition-colors duration-200"
          >
            Certification
          </Link>
        </nav>
        <div className="hidden lg:flex items-center gap-5">
          <Link
            to="/training"
            data-testid="nav-profile-link"
            className="text-xs font-mono uppercase tracking-widest text-muted-foreground hover:text-sky-600 transition-colors"
          >
            My Profile
          </Link>
          <Link
            to="/login"
            data-testid="nav-admin-link"
            className="text-xs font-mono uppercase tracking-widest text-muted-foreground hover:text-sky-600 transition-colors"
          >
            Admin
          </Link>
          <a
            href="#demo"
            data-testid="nav-book-demo-cta"
            className="inline-flex items-center rounded-md bg-cadmium px-5 py-2.5 text-sm font-semibold text-white transition-all duration-200 hover:bg-cadmium-hover hover:-translate-y-0.5 active:scale-[0.98]"
          >
            Book a Demo
          </a>
        </div>
        <button
          className="lg:hidden text-slate-900 p-2"
          onClick={() => setOpen(!open)}
          data-testid="nav-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-white border-b border-slate-200 px-6 py-5 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm font-medium text-muted-foreground hover:text-slate-900"
            >
              {l.label}
            </a>
          ))}
          <Link to="/certification" onClick={() => setOpen(false)} className="text-sm font-medium text-muted-foreground hover:text-slate-900">
            Certification
          </Link>
          <Link to="/training" onClick={() => setOpen(false)} data-testid="nav-profile-link-mobile" className="text-sm font-medium text-muted-foreground hover:text-slate-900">
            My Profile
          </Link>
          <Link to="/login" className="text-xs font-mono uppercase tracking-widest text-muted-foreground">
            Admin
          </Link>
          <a
            href="#demo"
            onClick={() => setOpen(false)}
            className="inline-flex w-fit items-center rounded-md bg-cadmium px-5 py-2.5 text-sm font-semibold text-white"
          >
            Book a Demo
          </a>
        </div>
      )}
    </header>
    </>
  );
};
